import {useReachGoalCallback, useReachGoalEffect} from '@yandex-delivery/blocks'
import React, {useCallback} from 'react'

import {MetrikaGoals} from './Payment.consts'

export const usePaymentButton = () => {
  const reachGoalCallback = useReachGoalCallback()
  useReachGoalEffect(MetrikaGoals.SHOWN, {buttonName: 'pay_on_delivery'})

  return useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation()

      reachGoalCallback(MetrikaGoals.TAPPED, {buttonName: 'pay_on_delivery'})
    },
    [reachGoalCallback],
  )
}
